<template>
    <div class="box">
        <div class="header">
            <div class="title">{{ $t('components.newhome.quickTools') }}</div>
        </div>
        <div class="content">
            <div v-for="(item,index) in allData" 
                :key="index"
                @click="gotoDataDetail(item.id,item.flType)"
                class="item">
                <img src="@/assets/data1.png" alt="">
                <p>{{item.nameCn}}</p>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    name: 'Utils',
    props: {
        allAlgorithmObj: Object
    },
    data() {
        return {
            allData: [],
        }
    },
    methods: {
        gotoDataDetail(id,flType) {
            this.$router.push({
                name: 'algorithmDetail',
                query: {
                    id:  id,
                    flType:flType,
                    from: 'Home'
                }
            })
        },
    },
    watch: {
        allAlgorithmObj(newData,oldData) {
            this.allData = newData.records
        }
    }
}
</script>
<style lang="scss" scoped>
.box {
    padding: 30px;

    .header {
        margin-bottom: 30px;

        .title {
            font-size: 24px;
            font-weight: 700;
            color: #3A4755;
        }
    }

    .content {
        display: flex;

        .item {
            margin-right: 30px;
            text-align: center;
            cursor: pointer;
            width: 160px;

            img {
                width: 100px;
                height: 100px
            }

            p {
                width: 100%;
                font-size: 20px;
                font-weight: 700;
                color: #3A4755;
                // padding-left: 10px;
                
                /* A. 强制长单词换行 */
                /* 因为你的文本是下划线连接的长字符串，没有空格，必须加这一句，否则它死活不换行 */
                word-break: break-all; 
                
                /* B. 限制行数并显示省略号 (Webkit内核浏览器通用写法，兼容性很好) */
                display: -webkit-box;           /* 将对象作为弹性伸缩盒子模型显示 */
                -webkit-box-orient: vertical;   /* 设置或检索伸缩盒对象的子元素的排列方式 */
                -webkit-line-clamp: 2;          /* 限制在一个块元素显示的文本的行数，这里写 2 就显示两行 */
                overflow: hidden;               /* 超出部分隐藏 */
                
                /* C. 一些排版微调 */
                text-align: center;
                line-height: 1.2;               /* 行高设小一点，避免两行占位太高 */
                margin-top: 5px;
            }
        }
    }
}
</style>
